import { useAxiosModule } from '@/modules/_shared/axios'
import * as types from './types'

const {
    getFromApi,
    postToApi,
    putToApi,
    deleteInApi
} = useAxiosModule()

export type ElectronicOperatorsResponse = types.ElectronicOperatorsListModel[]
export const getElectronicOperators = async () =>
    getFromApi<ElectronicOperatorsResponse>('organizations/billing-electronic-operators')

export type AddElectronicOperatorRequest = types.AddElectronicOperator
export const addElectronicOperator = async (req: AddElectronicOperatorRequest) =>
    await postToApi<null>('organizations/billing-electronic-operators/', req)

export type UpdateElectronicOperatorRequest = types.ChangeElectronicOperator
export const updateElectronicOperator = async (electronicOperatorId: string, req: UpdateElectronicOperatorRequest) =>
    await putToApi<null>(`organizations/billing-electronic-operators/${electronicOperatorId}`, req)

export const deleteElectronicOperator = async (electronicOperatorId: string) =>
    await deleteInApi<null>(`organizations/billing-electronic-operators/${electronicOperatorId}`)
